import React, { useCallback } from 'react';
import {
  Box,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel
} from '@mui/material';

import DebouncedTextField from '../../Utils/debounce';

export default function ModelloCognitivo({ parameters, setParameters }) {

  const set = (key, value) =>
    setParameters(prev => ({ ...prev, [key]: value }));

  const setField = useCallback((key, value) => {
    setParameters(prev => ({ ...prev, [key]: value }));
  }, []);

  const toggleRadio = (key, newValue) =>
    set(key, parameters[key] === newValue ? '' : newValue);

  const p = parameters;

  return (
    <Box sx={{ width: '50ch', display: 'grid', gap: 2 }}>

      <Box sx={{ p: 3, mb: 2, border: '1px solid rgba(0,0,0,0.23)', borderRadius: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
        <Box component="h1" sx={{ m: 0, fontSize: '1.8rem', fontWeight: 'bold', color: '#1976d2' }}>
          Accertamento Infermieristico
        </Box>
        <Box component="p" sx={{ m: 0, mt: 1, fontSize: '1rem', color: 'text.secondary' }}>
          Modello cognitivo
        </Box>
      </Box>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Parla italiano</FormLabel>
        <RadioGroup row value={p.italiano ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('italiano', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('italiano', 'false')} />} label="No" />
        </RadioGroup>
        {p.italiano === 'false' && (
          <DebouncedTextField
            size="small"
            label="Lingua parlata"
            value={p.linguaParlata ?? ''}
            onChange={(val) => setField('linguaParlata', val)}
            required
            sx={{ width: 220 }}
          />
        )}
      </FormControl>

      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Linguaggio normale</FormLabel>
        <RadioGroup row value={p.linguaggioNormale ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('linguaggioNormale', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('linguaggioNormale', 'false')} />} label="No" />
        </RadioGroup>
        {p.linguaggioNormale === 'false' && (
          <DebouncedTextField
            size="small"
            label="Disturbi del linguaggio"
            value={p.disturbiLinguaggio ?? ''}
            onChange={(val) => setField('disturbiLinguaggio', val)}
            required
            sx={{ width: 260 }}
          />
        )}
      </FormControl>

    </Box>
  );
}